import { differenceInSeconds, differenceInMinutes, differenceInHours, differenceInDays } from "date-fns";

const calculateTimeRemaining = selectedDate => {
  const now = new Date();
  const targetDate = new Date(selectedDate);
  targetDate.setHours(23, 59, 59, 0);
  const seconds = differenceInSeconds(targetDate, now) % 60;
  const minutes = differenceInMinutes(targetDate, now) % 60;
  const hours = differenceInHours(targetDate, now) % 24;
  const days = differenceInDays(targetDate, now);

  return {
    days: days.toString(),
    hours: hours.toString(),
    minutes: minutes.toString(),
    seconds: seconds.toString(),
  };
};

export { calculateTimeRemaining };
